import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from './Dashboard/navbar-menu/navbar-menu';
import Sidebar from './Dashboard/sidebar-menu/sidebar-menu';
import InternalContainer from './Dashboard/Iframe/internal/nav-internal-iframe';
import Welcome from './Pages/Welcome/Welcome';
import Measures from './Pages/Measures/Container';
import Period from './Pages/Period/Container';
import Platform from './Pages/Platform/Container';
import Space from './Pages/Space/Container';
import UserManagement from './Pages/User/Container';
import Maintenance from './Pages/Maintenance/Container';
import ExternalAuthorization from './Components/Authorization/ExternalAuthorization';
import './App.css';

function App(props) {
  const [user, setUser] = useState('');
  const [credential, setCredential] = useState('');

  useEffect(() => {
    setCredential(props.credentials);
    setUser(props.user);
  }, [props.credentials, props.user]);

  if (props.auth && props.user.IdRol != null && props.user.locale != null) {
    return (
      <Router>
        <Navbar user={user} />
        <div className='flex'>
          <Sidebar user={user} />
          <div className='content'>
            <Routes>
              <Route path="/" element={<Navigate to="/Welcome" replace />} />
              <Route path="/Welcome" element={<InternalContainer element={<Welcome />} />} />
              <Route path="/Measures" element={<InternalContainer element={<Measures user={user} credential={credential} />} />} />
              <Route path="/Period" element={<InternalContainer element={<Period user={user} credential={credential} />} />} />
              <Route path="/Space" element={<InternalContainer element={<Space user={user} credential={credential} />} />} />
              <Route path="/Request" element={<InternalContainer element={<Platform user={user} credential={credential} />} />} />
              {props.user?.profile === "Admin" && (
                <>
                  <Route path="/Maintenance" element={<InternalContainer element={<Maintenance user={user} credential={credential} />} />} />
                  <Route path="/Management" element={<InternalContainer element={<UserManagement user={user} credential={credential} />} />} />
                </>
              )}
              <Route path="*" element={<div>Página no encontrada</div>} />
            </Routes>
          </div>
        </div>
      </Router>
    );
  } else {
    return <ExternalAuthorization />;
  }
}

export default App;
